export default "__VITE_ASSET__PhcBo5Ww__"